export default "__VITE_ASSET__XOaD6lqQ__"